import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { ClusterId, ClusterizationRunId, ClusterReport } from '@playq/services-beetle';
import { GenericFailure, OffsetLimit } from '@playq/services-shared';

import { services2 } from '/api';
import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';

const reportKeys: unknown[] = ['cluster', 'query'];
export const useQueryCluster = (
  runId: ClusterizationRunId,
  clusterId: ClusterId,
  iterator: OffsetLimit,
  env: Environment,
  options?: IUseQueryOptionsExtended<ClusterReport | undefined, GenericFailure | Error>
) => {
  const {
    mutate: _mutate,
    refetch: _refetch,
    ...res
  } = useEitherQuery(
    reportKeys.concat(runId, clusterId, env, iterator),
    () => {
      return services2.audienceRequestsClusterizationService.queryCluster(runId, clusterId, iterator, env);
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return { ...res };
};
